import { render, staticRenderFns } from "./price_edit_dialog.vue?vue&type=template&id=363c2362&scoped=true"
import script from "./price_edit_dialog.vue?vue&type=script&lang=js"
export * from "./price_edit_dialog.vue?vue&type=script&lang=js"
import style0 from "./price_edit_dialog.vue?vue&type=style&index=0&id=363c2362&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c2362",
  null
  
)

export default component.exports